if(!customElements.get('ef-card-gallery'))customElements.define('ef-card-gallery',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.current=0;
  this.images=[...this.querySelectorAll('[data-gallery-image]')];this.buttons=[...this.querySelectorAll('[data-photo]')];
  this.addEventListener('pointermove',e=>{if(e.pointerType!=='mouse'||!matchMedia('(hover:hover)').matches||e.target.closest('button'))return;this.manual=false;const r=this.getBoundingClientRect();this.show(Math.min(this.images.length-1,Math.max(0,Math.floor((e.clientX-r.left)/r.width*this.images.length))));});
  this.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'&&!this.manual)this.show(0);});
  this.buttons.forEach((b,i)=>b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();this.manual=true;this.show(i);}));
  this.addEventListener('pointerdown',e=>{
   if(e.pointerType==='mouse'||e.target.closest('button'))return;
   this.swipe={id:e.pointerId,x:e.clientX,y:e.clientY};this.swiped=false;
  });
  this.addEventListener('pointerup',e=>{
   if(!this.swipe||e.pointerId!==this.swipe.id)return;
   const dx=e.clientX-this.swipe.x,dy=e.clientY-this.swipe.y;this.swipe=null;
   if(Math.abs(dx)<30||Math.abs(dx)<Math.abs(dy)*1.3)return;
   this.swiped=true;this.manual=true;this.show((this.current+(dx<0?1:-1)+this.images.length)%this.images.length);
   clearTimeout(this.swipeTimer);this.swipeTimer=setTimeout(()=>{this.swiped=false;},500);
  });
  this.addEventListener('pointercancel',()=>{this.swipe=null;});
  this.addEventListener('click',e=>{if(this.swiped&&!e.target.closest('button')){e.preventDefault();e.stopPropagation();this.swiped=false;}},true);
 }
 show(i){
  if(i===this.current)return;this.current=i;
  this.images.forEach((img,n)=>{img.hidden=true;if(n===i&&i!==0){if(!img.src){img.onload=()=>{if(this.current===n)img.hidden=false;};img.src=img.dataset.src;}if(img.complete&&img.naturalWidth)img.hidden=false;}});
  this.buttons.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));
 }
});
if(!customElements.get('ef-filter-launcher'))customElements.define('ef-filter-launcher',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.button=this.querySelector('button');
  this.button.setAttribute('aria-expanded','false');
  this.button.addEventListener('click',()=>{
   const details=this.closest('aside').querySelector('.mobile-facets__disclosure');const summary=details?.querySelector('summary');
   if(!summary||details.open)return;
   if(!details.dataset.efLauncherBound){
    details.dataset.efLauncherBound='true';
    summary.setAttribute('aria-label',this.dataset.closeLabel);
    summary.querySelector('.mobile-facets__close')?.removeAttribute('tabindex');
    details.addEventListener('toggle',()=>{
     this.button.setAttribute('aria-expanded',String(details.open));
     if(details.open)summary.focus();else this.button.focus();
    });
   }
   summary.click();
  });
 }
});
